import type { ParticipationEligibility } from "./types";

type ReferralOwnerIdentity = {
  identityChoice?: ParticipationEligibility["identityChoice"];
  nodeStatus?: ParticipationEligibility["activeStatus"];
  marketIsNodeIdentity?: number;
  ownInvitationType?: "NODE" | "ORDINARY";
};

/** Display the owner's identity, never the identity of an incoming referrer. */
export function isNodeReferralOwner(identity: ReferralOwnerIdentity): boolean {
  // The permanent Market choice also protects against legacy node-table entries
  // that were created from ordinary Market deposits.
  if (identity.identityChoice === "ORDINARY") return false;

  // Keep a legacy node's label when its invitation is missing/expired or its
  // Market mirror is no longer active. Choosing NODE without a position is not
  // enough to establish node identity.
  return (identity.identityChoice === "NODE" && identity.nodeStatus != null)
    || identity.marketIsNodeIdentity === 1
    || identity.ownInvitationType === "NODE";
}
